import React, { useEffect, useRef, useState, useCallback } from 'react';
import { prop } from 'ramda';
import { Icon } from 'js/components/common/Icon';
import { useDeviceSelector } from 'js/store/hooks';
import { LocalPopup } from 'js/components/common/Popup';
import { usePortletTranslations } from 'js/components/system/Portlet';

import Content from './Content';
import style from './index.scss';

export const PopoverVolatility = ({ onClose }) => {
    const popoverRef = useRef();
    const translate = usePortletTranslations();
    const handleBlur = useCallback((e) => !popoverRef.current.contains(e.target) && onClose(), [onClose]);

    useEffect(() => {
        addEventListener('click', handleBlur);
        return () => removeEventListener('click', handleBlur);
    }, [handleBlur]);

    return (
        <div
            ref={popoverRef}
            className={style.popover}
        >
            <Icon
                type="close_svg"
                onClick={onClose}
                className={style.close}
                aria-label={translate('playtech.mobile.system.popup.aria-label.close')}
            />
            <Content />
        </div>
    );
};

const volatilityPopupClassNames = {
    inner: style.popupInner,
    close: style.popupClose
};

export const PopupVolatility = ({ onClose }) => (
    <LocalPopup onClose={onClose}
        className={style.popup}
        classNames={volatilityPopupClassNames}
    >
        <Content onClose={onClose} />
    </LocalPopup>
);

export default () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const translate = usePortletTranslations();
    const [isInfoOpened, setIsInfoOpened] = useState(false);

    const toggleInfo = () => setIsInfoOpened(!isInfoOpened);

    return (
        <div className={style.info}>
            <Icon
                onClick={toggleInfo}
                type="volatility_info"
                aria-label={translate('payOutScore.help.title')}
            />
            {isInfoOpened && (
                isDesktop
                    ? <PopoverVolatility onClose={toggleInfo} />
                    : <PopupVolatility onClose={toggleInfo} />
            )}
        </div>
    );
};
